import {
  Avatar,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState, useRef } from "react";
import Style from "../styles/drawer.module.scss";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { ThemeContext } from "../context/ThemeProvider";
import { useDispatch, useSelector } from "react-redux";
import { myProfileAction } from "../redux/toolkit/profile/my-profile";
import SnackBarUI from "./SnackUI";
import Person2Icon from "@mui/icons-material/Person2";
import backgroundImage from "../assets/img/Icon.png";
import backgroundImag from "../assets/img/add 3.svg";
import backgroundIma from "../assets/img/users.svg";
import backgroundIm from "../assets/img/live.png";
import upcomingIcon from "../assets/img/upcoming 1.png";
import pauseIcon from "../assets/img/Vector.svg";
import pastMission from "../assets/img/time-past 1.png";
import postLogger from "../assets/img/PostbackLoer.png";
import barChart from "../assets/img/bar-chart-square-w02.svg";
import supportColorIcon from "../assets/img/support.svg";
import createCustumWhiteColorIcon from "../assets/img/createIconWhite.svg";
import usersWhiteColorIcon from "../assets/img/usersWhite.svg";
import liveMissionWhiteColorIcon from "../assets/img/liveWhite.svg";
import upcominMissiongWhiteColorIcon from "../assets/img/upcoming 1White .svg";
import pauseMissionWhiteColorIcon from "../assets/img/pause.svg";
import pastMissionWhiteColorIcon from "../assets/img/time-past 1White.svg";
// import {postBackLoggersWhiteColorIcon as PostBackLoggers}from "../assets/img/PostBackLoggerWhite.svg"
import { ReactComponent as PostBackLoggers } from "../assets/img/PostBackLoggerWhite.svg";

import supportKnowledgeWhiteColorIcon from "../assets/img/supportWhite.svg";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import TerminalIcon from "@mui/icons-material/Terminal";
import Logo from "../assets/img/real_logo.svg";
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
// import NewDashboardIcon from "../../public/assets/newIcons/NewDashboardIcon";

import NewDashboardIcon from "../assets/newIcons/NewDashboardIcon";
import StaticsIcons from "../assets/newIcons/StaticsIcons";
import AppIcon from "../assets/newIcons/AppIcon";
import AppListIcons from "../assets/newIcons/AppListIcons";
import UserIcons from "../assets/newIcons/UserIcons";
import PostBackIcons from "../assets/newIcons/PostBackIcons";
import TestPostBackIcons from "../assets/newIcons/TestPostBackIcons";
import PayoutIcon from "../assets/newIcons/PayoutIcon";
import ChargeBackIcon from "../assets/newIcons/ChargeBackIcon";
import AccountManagerIcon from "../assets/newIcons/AccountManagerIcon";
import IntigrationUrl from "../assets/newIcons/IntigrationUrl";
import useScreenWidth from "../hooks/useScreenWidth";
import { Logout } from "@mui/icons-material";

export default function DrawerUI() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { drawerSilde, setDrawerSilde } = useContext(ThemeContext);
  const [snakbar, setSnakbar] = useState(false);
  const dispatch = useDispatch();
  const [showMobileBar, setShowMobileBar] = useState(false);
  const screenWidth = useScreenWidth()
  const [menuVisible, setMenuVisible] = useState(false);
  const [profileAnchor, setProfileAnchor] = useState();
  
  const myProfileSelector = useSelector((state) => state.myProfile);
  const { data: profileData, status, message } = myProfileSelector;
  const myProfile = useSelector((state) => state.myProfile);
  const {  data } = myProfile;

  const sidebarRef = useRef(null);

  if (status === 401) {
    setTimeout(() => {
      localStorage.clear();
      window.location.href = "/login";
    }, 2000);
  }

  const listOFSidebar = [
    {
      primary: "Dashboard",
      sideIcon:
        pathname !== "/" ? (
          <NewDashboardIcon height="20px" width="20px" color="#FFF" />
        ) : (
          <NewDashboardIcon height="20px" width="20px" color="#000" />
        ),
      href: "/",
    },
    {
      primary: "Statistics",
      sideIcon:
        pathname !== "/stats" ? (
          <StaticsIcons height="24px" width="24px" color="#FFF" />
        ) : (
          <StaticsIcons height="24px" width="24px" color="#000" />
        ),
      href: "/stats",
    },
    {
      primary: "App Stats",
      sideIcon:
        pathname !== "/appStats" ? (
          <AppIcon height="24px" width="24px" color="#FFF" />
        ) : (
          <AppIcon height="24px" width="24px" color="#000" />
        ),
      href: "/appStats",
    },
    {
      primary: "App List",
      sideIcon:
        pathname !== "/apps" ? (
          <AppListIcons height="24px" width="24px" color="#FFF" />
        ) : (
          <AppListIcons height="24px" width="24px" color="#000" />
        ),
      href: "/apps",
    },
    {
      primary: "Users",
      sideIcon:
        pathname !== "/users" ? (
          <UserIcons height="24px" width="24px" color="#FFF" />
        ) : (
          <UserIcons height="24px" width="24px" color="#000" />
        ),
      href: "/users",
    },

    {
      primary: "Postbacks",
      sideIcon:
        pathname !== "/postback-loggers" ? (
          <PostBackIcons height="24px" width="24px" color="#FFF" />
        ) : (
          <PostBackIcons height="24px" width="24px" color="#000" />
        ),
      href: "/postback-loggers",
    },
    {
      primary: "Test Postback",
      sideIcon:
        pathname !== "/test-postback" ? (
          <TestPostBackIcons height="24px" width="24px" color="#FFF" />
        ) : (
          <TestPostBackIcons height="24px" width="24px" color="#000" />
        ),
      href: "/test-postback",
    },
    {
      primary: "Payouts",
      sideIcon:
        pathname !== "/payouts" ? (
          <PayoutIcon height="24px" width="24px" color="#FFF" />
        ) : (
          <PayoutIcon height="24px" width="24px" color="#000" />
        ),
      href: "/payouts",
    },

    {
      primary: "ChargeBack",
      sideIcon:
        pathname !== "/charege-back-data" ? (
          <ChargeBackIcon height="24px" width="24px" color="#FFF" />
        ) : (
          <ChargeBackIcon height="24px" width="24px" color="#000" />
        ),
      href: "/charege-back-data",
    },
    {
      primary: "Account Manager",
      sideIcon:
        pathname !== "/account-manager" ? (
          <AccountManagerIcon height="24px" width="24px" color="#FFF" />
        ) : (
          <AccountManagerIcon height="24px" width="24px" color="#000" />
        ),
      href: "/account-manager",
    },
    {
      primary: "Integration",
      sideIcon:
        pathname !== "/integration" ? <IntigrationUrl width="24px"  height="24px" color="#FFF" /> 
        : <IntigrationUrl  width="24px"  height="24px" color="#000" />,
      href: "https://prorewards.gitbook.io/real-opinion",
      // target: "_blank",
    },
  ];

  useEffect(() => {
    const fetchProfile = async () => {
      const profile = await dispatch(myProfileAction());
      setSnakbar(true);
    };
    fetchProfile();
  }, [dispatch]);

  

  const styles = {
    listItem: {
      "&:hover": {
        background:
          "linear-gradient(177.64deg, #FFB100 10.65%, #FE299F 275.27%)",
      },
    },
  };

  const logOutFunc = () => {
    localStorage.removeItem("auth_token");
    window.location.reload()
    navigate("/login");
  };

  return (
    <>
      <Stack
        ref={sidebarRef}
        style={{
          margin: 0,
          padding: 0,
          background: "rgba(31, 31, 31, 1)",
          overflowY: "auto",
          overflowX: "hidden",
          scrollbarWidth: "none",
        }}
        className={drawerSilde ? Style.drawer_open : Style.drawer_close}
      >
        <Box
          sx={{
            paddingBlock: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <img src={Logo} />
          { screenWidth <= 700 &&  <IconButton
          onClick={(event) => {
            setMenuVisible(true);
            setProfileAnchor(event.currentTarget);
          }}
        >
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <Avatar sx={{background: "linear-gradient(177.64deg, #FFB100 10.65%, #FE299F 275.27%)" }} >{data?.name?.charAt(0)?.toUpperCase()}</Avatar>
          </Stack>
         
          <Menu
          anchorEl={profileAnchor}
           open={menuVisible}
         sx={{
          zIndex: 9999999,
          
         }}
        onClose={() => setMenuVisible(false)}
      >
        <Box sx={{ p: 2, width: 200, }}>
          <Typography sx={{ mb: 1 }} variant="subtitle2">
            👋 Hey,<strong>{" " +data.name}</strong>
          </Typography>
        </Box>
        <Divider />
        <MenuItem onClick={() => navigate("/profile")}>
          <ListItemIcon>
            <Person2Icon color="#000" />
          </ListItemIcon>
          Profile
        </MenuItem>
        <Divider />
        <MenuItem onClick={logOutFunc}>
          <ListItemIcon>
            <Logout color="primary" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
        </IconButton >}
        </Box>

        {/* <Divider /> */}
        <List>
          {listOFSidebar.map((item, index) => {
            return (
              <Link
                key={index}
                to={item?.href}
                style={{ textDecoration: "none" }}
                onClick={(e) => {
                  // Prevent scroll reset
                  if(screenWidth <= 700){
                   setDrawerSilde(false)
                  }
              
                  const sidebar = sidebarRef.current;
                  if (sidebar) {
                    const scrollPosition = sidebar.scrollTop;
                    setTimeout(() => {
                      sidebar.scrollTop = scrollPosition; // Preserve scroll position
                    }, 0);
                  }
                }}
              >
                <ListItem
                  className={item?.href == pathname && Style.actvie_link}
                  key={index}
                  disablePadding
                >
                  <ListItemButton
                    sx={item?.href !== pathname && styles.listItem}
                  >
                    <ListItemIcon
                      className={
                        item?.href === pathname
                          ? Style.blackColor
                          : Style.whiteColor
                      }
                    >
                      {item?.sideIcon}
                    </ListItemIcon>
                    {drawerSilde && (
                      <ListItemText
                        className={
                          item?.href === pathname
                            ? Style.blackColor
                            : Style.whiteColor
                        }
                        primary={item?.primary}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              </Link>
            );
          })}
        </List>
      </Stack>
      {snakbar && status !== 200 && (
        <SnackBarUI
          state={snakbar}
          setState={setSnakbar}
          status={status}
          message={message}
        />
      )}
    </>
  );
}
